module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_10-99c7f0580f33b0c3c0c530f30229ced2.svg";